import React, { useState } from 'react';
import FileUploader from '../components/FileUploader';
import ProcessingIndicator from '../components/ProcessingIndicator';
import { splitPDF } from '../utils/pdfUtils';
import JSZip from 'jszip';
import { saveAs } from 'file-saver';
import './ToolPage.css';

const PDFSplit = () => {
    const [files, setFiles] = useState([]);
    const [processing, setProcessing] = useState(false);
    const [processedFiles, setProcessedFiles] = useState([]);

    const handleFilesSelected = (selectedFiles) => {
        setFiles(selectedFiles);
        setProcessedFiles([]);
    };

    const handleSplit = async () => {
        if (files.length === 0) return;

        setProcessing(true);
        const allSplitFiles = [];

        try {
            for (const file of files) {
                const splitFiles = await splitPDF(file);
                allSplitFiles.push(...splitFiles);
            }
            setProcessedFiles(allSplitFiles);
        } catch (error) {
            alert('Split failed: ' + error.message);
        } finally {
            setProcessing(false);
        }
    };

    const handleDownload = async () => {
        const zip = new JSZip();
        processedFiles.forEach((file) => {
            zip.file(file.name, file);
        });
        const content = await zip.generateAsync({ type: 'blob' });
        saveAs(content, 'split_pdfs.zip');
    };

    return (
        <div className="tool-page">
            <div className="tool-header">
                <h1>✂️ PDF Split</h1>
                <p>Split PDF file into separate pages</p>
            </div>

            <div className="tool-content">
                <FileUploader
                    accept="application/pdf"
                    onFilesSelected={handleFilesSelected}
                    title="Upload PDF File"
                />

                {files.length > 0 && !processing && processedFiles.length === 0 && (
                    <div className="tool-controls">
                        <button className="btn btn-primary" onClick={handleSplit}>
                            Split PDF
                        </button>
                    </div>
                )}

                {processing && <ProcessingIndicator message="Splitting PDF..." />}

                {processedFiles.length > 0 && (
                    <div className="results">
                        <h3>Split Complete!</h3>
                        <p>Generated {processedFiles.length} PDF file(s)</p>
                        <button className="btn btn-primary" onClick={handleDownload}>
                            Download All
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default PDFSplit;
